/**
 * Cleans the description of our additions, and makes links in the description
 *  open in a new tab.
 * @param description
 */
export default function formatEventDescription(description: string) {
	if (description.length === 0) return "";
	const trimmedDescription = description.startsWith("✈️ This meeting has") ? description.split("✈️")[2] : description;

	const el = document.createElement("div");
	el.innerHTML = trimmedDescription;

	const links = el.getElementsByTagName("a");
	for (let link of links) {
		link.target = "_blank";
		link.rel = "noopener noreferrer";
	}

	return el.innerHTML;
}
